import { http } from "./http";

export type TipoCeremonia = "IGLESIA" | "CIVIL" | "RECEPCION" | string;

export type Ceremonia = {
  id: number;
  eventoId: number;

  tipo: TipoCeremonia;
  nombre: string | null;

  lugarNombre: string | null;
  direccion: string | null;

  lat: number | null;
  lng: number | null;

  urlMaps: string | null;

  fechaHora: string; // ISO
  orden: number | null;
};

export type CreateCeremoniaRequest = {
  tipo: TipoCeremonia;
  nombre: string;
  lugarNombre: string;
  direccion: string;
  lat?: number | null;
  lng?: number | null;
  urlMaps?: string | null;
  fechaHora: string; // ISO
};

export type UpdateCeremoniaRequest = {
  tipo?: TipoCeremonia;
  nombre?: string;
  lugarNombre?: string;
  direccion?: string;
  lat?: number | null;
  lng?: number | null;
  urlMaps?: string | null;
  fechaHora?: string; // ISO
  orden?: number | null;
};

export async function listarCeremonias(eventoId: number) {
  return http.request<Ceremonia[]>(
    `/api/admin/eventos/${eventoId}/ceremonias`,
    { method: "GET" }
  );
}

export async function crearCeremonia(eventoId: number, body: CreateCeremoniaRequest) {
  return http.request<Ceremonia>(
    `/api/admin/eventos/${eventoId}/ceremonias`,
    {
      method: "POST",
      body,
    }
  );
}

export async function actualizarCeremonia(
  eventoId: number,
  ceremoniaId: number,
  body: UpdateCeremoniaRequest
) {
  return http.request<Ceremonia>(
    `/api/admin/eventos/${eventoId}/ceremonias/${ceremoniaId}`,
    {
      method: "PUT",
      body,
    }
  );
}

export async function eliminarCeremonia(eventoId: number, ceremoniaId: number) {
  await http.request<void>(
    `/api/admin/eventos/${eventoId}/ceremonias/${ceremoniaId}`,
    { method: "DELETE" }
  );
}